import { AuthService } from '../../../base/services/auth.service';
import { FilterOperator, ImportProtocolClient } from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { FilterDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ImportConfigurationProtocolService extends ShowInactiveService implements IAdaptorService {
  public selectedProtocolId: number;

  constructor(
    private protocolClient: ImportProtocolClient,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (filters == null) {
      filters = [];
    }
    
    if (this.selectedProtocolId) {
      filters.push(new FilterDTO({ field: 'id', operator: FilterOperator.Equal, value: this.selectedProtocolId.toString(), isComplex: false }));
    }
    return this.protocolClient.searchProtocols(this.authService.getUserInfo().clientId, skip, take, sortBy, sortDirection, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public setProtocolAsFixed(id: number) {
    this.spinnerService.show();
    return this.protocolClient.setAsFixed(id).pipe(
      tap(() => {
        this.toastService.showSuccess('i18n.domain.import-protocol.messages.set-as-fixed.title', 'i18n.domain.import-protocol.messages.set-as-fixed.success-text');
      }),
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError((err) => {
        this.toastService.showError('i18n.domain.import-protocol.messages.set-as-fixed.title', 'i18n.domain.import-protocol.messages.set-as-fixed.error-text', null, ErrorType.serverError);
        throw err;
      })
    );
  }

}
